import { render } from "./TabComponent.vue?vue&type=template&id=13cff464&scoped=true"
import script from "./TabComponent.vue?vue&type=script&lang=js"
export * from "./TabComponent.vue?vue&type=script&lang=js"

import "./TabComponent.vue?vue&type=style&index=0&id=13cff464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cff464"]])

export default __exports__